import React from 'react';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import translate from '@/lib/intl/translate';

type QuickFiltersPopoverProps = {
  children: React.ReactNode;
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  handleClose: () => void;
  handleSubmit: (e: React.SyntheticEvent) => void;
  id: string;
  label: string;
};

function QuickFiltersPopover({
  children,
  open,
  anchorEl,
  handleClose,
  handleSubmit,
  id,
  label,
}: QuickFiltersPopoverProps) {
  return (
    anchorEl && (
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handleClose}
        aria-label={label}
      >
        <form onSubmit={handleSubmit} aria-label={translate('FILTERS')}>
          {children}
          <div className="flex flex-row-reverse border-t border-grey-300 px-2 py-3">
            <Button color="primary" type="submit" variant="contained">
              {translate('APPLY')}
            </Button>
            <Button onClick={handleClose} type="button" variant="text">
              {translate('CANCEL')}
            </Button>
          </div>
        </form>
      </Popover>
    )
  );
}

export default QuickFiltersPopover;
